module.exports = __webpack_public_path__ + "img/click_tab1.a3dcc600.png";